export default "__VITE_ASSET__DpL1tHUu__"